<template>
  <div class="wrapper">
    <h1>提出物を登録</h1>
    <div class="form">
      <ul class="radio-a">
        <li>
          <input name="type" id="is-option-a" type="radio" value="true" v-model="submitFlg">
          <label for="is-option-a">提出</label>
        </li>
        <li>
          <input name="type" id="is-option-b" type="radio" value="false" v-model="submitFlg">
          <label for="is-option-b">取消</label>
        </li>
      </ul>
      <div class="barcode">
        <input type="text" ref="barcode" v-model="inputText" @keydown.enter.prevent>
      </div>
    </div>
  </div>

  <div class="toast" v-if="errorFlg && toasted">
    エラー::<br>{{errorMsg}}&nbsp;<span>/</span>
  </div>
  <div class="toast" v-else-if="toasted">
    {{this.localStudents[this.studentsID]}}さん&nbsp;<span>/</span>&nbsp;{{this.localSubmissions[this.submissionsID]}}&nbsp;を<span v-if="submitFlg">提出</span><span v-else>取り消</span>しました。
  </div>

</template>

<script>

export default {
  props: [
    "submissions", "students", "submissionStatus"
  ],
  emits: [
    'save-status'
  ],
  data() {
    return {
      date: "",
      errorFlg: false,
      errorMsg: '',
      submitFlg: true, // 送信フラグ
      inputText: "",
      toasted: false,
      localSubmissions: this.submissions,
      localStudents: this.students,
      submissionsID: 0,
      studentsID: 0,
      localStatus: this.submissionStatus
    }
  },
  methods: {
    saveStatus() { // localStatusを上書き
      // console.log('Form:save');
      // console.log(this.localStatus);
      this.$emit("save-status", this.localStatus );
    },
    error(msg) {
      this.errorMsg = msg;
      this.inputText = ''; // inputを空に戻す
      this.errorFlg = true;
      this.toasted = true; //メッセージ表示
      setTimeout(() => { // ２秒後にトーストを消す
        this.errorFlg = false;
        this.toasted = false;
      }, 2000);

    }
  },
  created() {
    this.date = new Date().toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit",day: "2-digit"}).replaceAll('/', '-'); // 日付の取得
    this.submitFlg = true; // 提出にチェック
  },
  mounted() { // 描画時の処理
    this.$refs.barcode.focus(); // バーコードにフォーカス
  },
  watch: {
    inputText(e) { // inputTextを監視
      if( isNaN(e) ) { //数字以外が入力された->削除
        console.log(e+':notKazu');
        this.inputText = this.inputText.slice(0, -1);
        this.error('バーコードを読み取るか、提出物の番号を入力してください。');
        return false;
      }
      if( e.length == 7 ) { // 7 文字コード取得完了
        // エラーフラグ
        let err = 0;

        // バーコードから提出物IDと生徒IDを計算
        this.submissionsID = this.inputText % 1000;
        this.studentsID = this.inputText - this.submissionsID;

        // 生徒IDが存在するかチェック
        if( this.studentsID in this.localStudents === false ) {
          console.log('その生徒IDは存在しません。[stuId]');
          this.error('その生徒IDは存在しません。[stuId]');
          err++;
        }
        // 提出物IDが存在するかチェック
        if( this.submissionsID in this.localSubmissions === false ) {
          console.log('その提出物は存在しません。[subId]');
          this.error('その提出物は存在しません。[subId]');
          err++;
        }


        console.log(this.submissionsID, this.studentsID);
        console.log(this.localSubmissions[this.submissionsID]);
        console.log(this.localStudents[this.studentsID]);

        // 取り消し処理
        if(this.submitFlg == 'false') {
          this.submitFlg = false;
          console.log(this.submitFlg);

          // ネストが存在するかをチェック
          if(
            !this.localStatus[this.date] ||
            !this.localStatus[this.date][this.submissionsID]
          ) {
            console.log('まだ提出されていません。[date,id]');
            this.error('まだ提出されていません。[date,id]');
            err++;
          }

          // 値の位置を検索
          const index = this.localStatus[this.date][this.submissionsID].indexOf(this.studentsID);
          if( index === -1 ) { // ヒットなし
            console.log('まだ提出されていません。[stuId]');
            this.error('まだ提出されていません。[stuId]');
            err++;
          }

          // エラーのない時切り出し
          if( err === 0 ) {
            this.localStatus[this.date][this.submissionsID].splice(index, 1); // 切り出し
            this.saveStatus(); // 保存
          }
        }
        // 提出処理
        else {
          this.submitFlg = true;
          
          // エラー無しの時実行
          if(err === 0) {
            // 日付がなければ作る
            if(!this.localStatus[this.date]) {
              this.localStatus[this.date] = {};
              console.log("日付作成");
            }
            // 提出物がなければ作る
            if(!this.localStatus[this.date][this.submissionsID]) {
              this.localStatus[this.date][this.submissionsID] = [];
            }
            // 提出->配列に追加
            this.localStatus[this.date][this.submissionsID].push(this.studentsID);

            // 重複を省く
            this.localStatus[this.date][this.submissionsID] = [...new Set(this.localStatus[this.date][this.submissionsID])]

            // 保存
            this.saveStatus();

          }

        }

        this.toasted = true; //メッセージ表示
        this.inputText = ''; // inputを空に戻す
        setTimeout(() => { // ２秒後にトーストを消す
          this.toasted = false;
        }, 2000);
      }

    }

  }
};

</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

h1 {
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 1em;
    font-size: 3vw;
    z-index: 1;
}

.form {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: white;
  z-index: 2;
}

.radio-a{
  display: flex;
  justify-content: center;
  margin-block: 20px;
  gap: 10px;
  padding: 0;
}
.radio-a li {
  list-style: none;
}
.radio-a input[type="radio"]{
  position: absolute;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
}
.radio-a label{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  background-color: #ddd;
  border: 3px solid #ddd;
  color: #fff;
  aspect-ratio: 1 / 1;
  width: 80px;
  cursor: pointer;
  transition: .3s;
}
.radio-a input[type="radio"]:checked + label{
  background-color: #006699;
  border-color: #006699;
  cursor: default;
}
@media (hover: hover){
  .radio-a li:hover label{
    border-color: #006699;
  }
}

.barcode {
  display: flex;
  margin-left: 20px;
  width: 400px;
  height: 80px;
  box-sizing: border-box;
  border-bottom: #006699 1px solid;
}
.barcode input[type="text"] {
  border: none;
  outline: none;
  align-items: baseline;
  width: 400px;
  font-size: 2vw;
  font-weight: bold;
  color: #006699;
  text-align: center;
}

div.toast {
    position: fixed;
    right: 30px;
    opacity: 0;
    font-family: Arial, Helvetica, sans-serif;
    color: white;
    font-weight: bold;
    padding: 15px 30px;
    border-radius: 10px 10px;
    background-color: rgb(28, 28, 28);
    animation-duration: 2s;
    animation-delay: 0s;
    animation-name: fadein;
    animation-fill-mode: forwards;
    box-shadow: 5px 5px 50px rgb(176, 176, 176);
}
div.toast span {
    color:rgb(61, 194, 0);
    padding-left: 5px;
    font-weight: bolder;
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}
@keyframes fadein {
    0% {
        opacity: 0;
        bottom: 0;
    }
    15% {
        opacity: 1;
        bottom: 20;
    }
    95% {
        opacity: 1;
        bottom: 20;
    }
    100% {
        opacity: 0;
        bottom: 0;
    }
}
</style>